<template>
  <div>
    <v-expand-transition>
      <div>
        <v-switch
          v-model="focusOnOneLegalProblem"
          :label="$t('filters.legalProblems.focusOnOneLegalProblem.label')"
          color="primary"
          class="mt-0"
        >
        </v-switch>
        <v-expand-transition>
          <div v-show="focusOnOneLegalProblem">
            <v-select
              v-model="selectedLegalProblem"
              :items="legalProblemItems"
              :label="$t('filters.legalProblems.legalProblem.label')"
              color="primary"
            >
              <template v-slot:selection="{ item }">
                <v-chip color="primary" small>
                  <span>{{ item.text }}</span>
                </v-chip>
              </template>
            </v-select>
            <v-radio-group
              v-model="selectedLegalProblemType"
              row
              hide-details
              class="mt-0"
            >
              <v-radio
                v-for="type in legalProblemTypeOptions"
                :key="type"
                :label="
                  $t(`filters.legalProblems.legalProblemType.options.${type}`)
                "
                :value="type"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-expand-transition>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["filterSelected", "filterOptions"]),
    legalProblemTypeOptions() {
      return this.filterOptions("legalProblemType");
    },
    legalProblemOptions() {
      return this.filterOptions("legalProblem");
    },
    legalProblemItems() {
      return this.legalProblemOptions.map(option => ({
        value: option,
        text: this.$t(`filters.legalProblems.legalProblem.options.${option}`)
      }));
    },
    focusOnOneLegalProblem: {
      get() {
        return this.filterSelected("focusOnOneLegalProblem");
      },
      set(value) {
        this.updateFilter({ filter: "focusOnOneLegalProblem", value });
      }
    },
    selectedLegalProblemType: {
      get() {
        return this.filterSelected("legalProblemType");
      },
      set(value) {
        this.updateFilter({ filter: "legalProblemType", value });
      }
    },
    selectedLegalProblem: {
      get() {
        return this.filterSelected("legalProblem");
      },
      set(value) {
        this.updateFilter({ filter: "legalProblem", value });
      }
    }
  },
  methods: {
    ...mapActions(["updateFilter"])
  }
};
</script>